export default "__VITE_ASSET__aFsXi9hV__"